import styled from "styled-components";

export const PopupAlertBox = styled.div`
  position: fixed;
  display: flex;
  width: 100vw;
  height: 100svh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.3);
  /* backdrop-filter: blur(1.6px); */
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const PopupAlert = styled.div`
  display: flex;
  min-width: 300px;
  max-width: 328px;
  max-height: 560px;
  background: white;
  box-shadow: 0px 2px 10px -4px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  flex-direction: column;
`;

export const PopupTitle = styled.div`
  padding: 16px;
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
  color: #262626;
`;

export const PopupContent = styled.div`
  padding: 0 16px;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
  white-space: pre-line;
  color: #737373;
  overflow-y: auto;
`;

export const PopupButtons = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  justify-content: center;
  gap: 12px;

  button {
    width: 100%;
    height: 48px;
    padding: 0 16px;
    font-size: 16px;
    font-weight: 500;
    border: none;
    border-radius: 6px;
    transition: all 0.2s ease;
    cursor: pointer;

    &.confirm_btn {
      color: white;
      background: #f57c00;

      &:hover {
        background: #f9830d;
      }
    }

    &.cancel_btn {
      color: #525252;
      background: #f5f5f5;

      &:hover {
        background: #e2e2e2;
      }
    }
  }
`;
